"use client";

import { persistSubmittedLeadValues } from "@marketing-sites/marketo/durable-lead-store";

// Kept app-local rather than in the shared submission hooks: pioneer consumes
// those too and is deliberately outside the 14-day store.
export function rememberSubmittedLeadValues(
  values: Record<string, unknown> | undefined | null,
): void {
  if (!values) return;
  persistSubmittedLeadValues(values);
}
